import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { CreateAssetWrapper, PageHeader } from "./Lease.styled";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import { StyledContainer } from "../../globalStyle/GlobalStyle";
import { TabListCreateAsset } from "./data";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import CreateProductInfo from "./partials/CreateProductInfo";
import CreateProductCatalog from "./partials/CreateProductCatalog";
import CreateLeaseInfo from "./partials/CreateLeaseInfo";
import CreateSummary from "./partials/CreateSummary";
import { BiArrowBack } from "react-icons/bi";
// import { toast } from "react-toastify";

function CreateAsset() {
	const navigate = useNavigate();
	let { current_tab } = useParams();
	const [currentTab, setCurrentTab] = useState(current_tab || TabListCreateAsset[0].id);
	const [formData, setFormData] = useState({});

	useEffect(() => {
		if (current_tab) {
			setCurrentTab(current_tab);
		}
	}, [current_tab]);

	const handleTabChange = (category) => {
		const allowedTabs = ["product_info", "product_catalog"];
		if (allowedTabs.includes(category)) {
			navigate(`/lease/create_asset/${category}`);
		}
	};

	const CurrentTabSection = (props) => {
		if (currentTab === "product_info") {
			return <CreateProductInfo {...props} />;
		} else if (currentTab === "product_catalog") {
			return <CreateProductCatalog {...props} />;
		} else if (currentTab === "lease_info") {
			return <CreateLeaseInfo {...props} />;
		} else if (currentTab === "summary") {
			return <CreateSummary {...props} />;
		}
	};

	const handleBackButton = () => {
		navigate("/lease/created_assets?filter=quick_lease");
	};

	return (
		<AdminDashboardLayout>
			<StyledContainer>
				<PageHeader>
					<div className='topHeader flex'>
						<div onClick={handleBackButton} style={{ color: "#006770" }} className='flex gap-2 border px-3'>
							<BiArrowBack size={24} />
							<p>Go back</p>
						</div>
					</div>

					<FilterCategory
						currentTab={currentTab}
						tabList={TabListCreateAsset}
						handleClick={(category) => handleTabChange(category)}
					/>
				</PageHeader>

				<CreateAssetWrapper>
					<FormContainer>
						<CurrentTabSection formData={formData} setFormData={setFormData} />
					</FormContainer>
				</CreateAssetWrapper>
			</StyledContainer>
		</AdminDashboardLayout>
	);
}

export default CreateAsset;
